module.exports = __webpack_public_path__ + "static/media/cookiepolicy.f5d4dc44.pdf";